module.exports = __webpack_public_path__ + "img/ku.c5aa95d9.svg";